module.exports = __webpack_public_path__ + "img/sm-facebook.5f8f8f4c.png";